import { useScrollPosition } from 'hooks/useScrollPosition'
import React from 'react'
import { Button } from 'semantic-ui-react'

export default function GoalPreferencesForm({ items, selectedItems, setSelectItems }) {
  const { scrollRef, isScrollable, isAtBottom } = useScrollPosition()

  function handleItemSelected(isActive, item) {
    if (isActive) {
      item.type = 'goal'
      setSelectItems([...selectedItems, item])
    } else {
      const newSelectedItem = selectedItems.filter((obj) => obj.id !== item.id)
      setSelectItems(newSelectedItem)
    }
  }

  return (
    <React.Fragment>
      <div
        ref={scrollRef}
        className="flex flex-wrap gap-2 mb-2 overflow-x-hidden overflow-y-auto onboarding-goal-scroll"
      >
        {items?.map((item) => {
          const isSelected = selectedItems.some((selected) => selected.id === item.id)
          return (
            <Button
              basic
              key={item.id}
              tabIndex="-1"
              onClick={(e) => {
                e.target.blur()
                handleItemSelected(!isSelected, item)
              }}
              size="medium"
              active={isSelected}
            >
              {item.name}
            </Button>
          )
        })}

        {isScrollable && !isAtBottom && (
          <div className="absolute bottom-0 z-10 flex justify-center w-full py-8 translate-y-1/2 pointer-events-none bg-gradient-to-b from-transparent to-white" />
        )}
      </div>
    </React.Fragment>
  )
}



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/components/GoalPreferencesForm/index.js